import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
export const useDelete = () => {
  const { mutate: deleteStakeholder, isPending } = useAppMutation([QueryKey.DELETE_STAKEHOLDER], {
    mutationFn: ({
      companyId,
      stakeholderId,
      subEmail,
    }: {
      companyId: string;
      stakeholderId: string;
      subEmail?: string;
    }) =>
      ApiService.delete(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'stakeholders', stakeholderId],
        },
        {
          queryParams: {
            subEmail,
          },
        },
      ),
  });
  return { deleteStakeholder, isPending };
};
